export const finishRegistrationSearchParam = 'finish-registration';
export const signupEmailSearchParam = 'signup-email';
